export const nuxtServerInit = async ({ dispatch }) => {}
export const nuxtClientInit = async ({ dispatch, state }) => {
  await dispatch('checkout/getCart')
  await dispatch('checkout/reservationTimeout', state.checkout.reservationTimeout)
}
